import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["activator", "activatorLabel", "target"]

  toggle() {
    const checked = this.activatorTarget.checked;
    this.activatorLabelTarget.textContent = checked ? "Tout décocher" : "Tout cocher";

    this.targetTargets.forEach(target => {
      target.checked = checked;
      target.parentElement.classList.toggle("checked", checked);
    })
  }
}
